import { Injectable } from '@angular/core';
import { HelperService } from '../helper/helper.service';
import { EnvironmentConfigService } from '../shared/environment-config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProductListAPIResponse } from '../../models/product-list';

@Injectable({
  providedIn: 'root'
})
export class ProductListService {

  apiConfig = {
    baseUrl: 'https://api2.travelx.ai',
    // baseUrl: 'http://a.gmr.in',
    path: '/api/getRetailersDetailsV2'
  };
  apiParams: any;


  public get productListServiceApi(): string {
    // tslint:disable-next-line: max-line-length
    let finalRequestParams = { ...this.envService.getDefaultApiParams(), ...this.apiParams };
    return this.productListServiceApi = `${this.envService.getRetailersDetailsV2Api()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }

  public set productListServiceApi(value: string) {
  }
  // tslint:disable-next-line: max-line-length
  // productListServiceApi = https://api.travelx.ai/api/getRetailersDetailsV2?airportid=1&storeId=3252&key=qw1op5cv8j0d&pid=gmr&uuid=6ac851bd-381c-4730-9e10-e4206a85b7b2&s_id=1559538980678&platformid=&dpi=480&platform=android
  constructor(private httpClient: HttpClient, private helperService: HelperService, private envService: EnvironmentConfigService) {
    this.initApiParams();
    // this.airportService.selectedAirport.subscribe(airportCode => this.apiParams.airport = airportCode );
  }

  initApiParams() {
    this.apiParams = {
      page: 1,
      perpage: 10,
      location: '',
      storeId: ''
    };
  }

  getProductsByStoreId(storeId: number, page: number, location: number, prefix: string): Observable<ProductListAPIResponse> {
    this.apiParams.storeId = storeId;
    this.apiParams.page = page;
    this.apiParams.locationid = location;
    this.apiParams.prefix = prefix || '';
    const guestId = localStorage.getItem('guestId');
    if (guestId != null) {
      this.apiParams.guestid = guestId;
    }
    return this.httpClient.get<ProductListAPIResponse>(this.productListServiceApi);
  }

}
